import { useStoreValue, storeSet } from '../../../../store';
import UserAvatar from '../../../UserAvatar';

const MODE_LABELS = { pen: 'Pen', pin: 'Pin', mood: 'Mood' };

const formatTimecode = (s) => {
    if (s == null) return '–';
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60);
    return `${m}:${sec.toString().padStart(2, '0')}`;
};

const AiNoteExtra = ({ messageId, extra }) => {
    const { noteType, startTimecode, endTimecode, layer, mood, canvasData } = extra;
    const activeAiNoteHighlight = useStoreValue('activeAiNoteHighlight');
    const penaiViewData = useStoreValue('penaiViewData');

    const isActive = noteType === 'pen'
        ? penaiViewData?.id === messageId
        : activeAiNoteHighlight === messageId;

    const handleClick = () => {
        if (noteType === 'pen') {
            storeSet('penaiViewData', isActive ? null : { id: messageId, canvasJson: canvasData ? JSON.parse(canvasData) : null });
        } else if (noteType === 'pin' || noteType === 'mood') {
            storeSet('activeAiNoteHighlight', isActive ? null : messageId);
        }
    };

    const isClickable = noteType === 'pen' || noteType === 'pin' || noteType === 'mood';

    return (
        <div
            className={`aiNoteExtra${isClickable ? ' aiNoteExtra--clickable' : ''}${isActive ? ' aiNoteExtra--active' : ''}`}
            onClick={isClickable ? handleClick : undefined}
        >
            <div className="aiNoteExtra__meta">
                <span className="aiNoteExtra__badge">{MODE_LABELS[noteType] ?? noteType}</span>
                {layer && <span className="aiNoteExtra__layer">{layer}</span>}
                {startTimecode != null && (
                    <span className="aiNoteExtra__range">
                        {formatTimecode(startTimecode)} → {formatTimecode(endTimecode)}
                    </span>
                )}
                {mood && <span className="aiNoteExtra__mood">{mood}</span>}
            </div>
        </div>
    );
};

const ChatMessage = ({ data }) => {
    const userData = useStoreValue('userData');
    const team = useStoreValue('team');

    const isMe = data.senderId === userData.id;
    const sender = isMe
        ? { name: userData.name, surname: userData.surname, avatarUrl: userData.profile_picture_url }
        : (() => {
            const member = team.find(m => m.senderId === data.senderId);
            return {
                name: member?.name ?? '',
                surname: member?.surname ?? '',
                avatarUrl: member?.profile_picture_url ?? null,
            };
        })();

    const time = data.createdAt
        ? new Date(data.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        : '';

    return (
        <div className={['chatMessage', isMe ? 'me' : ''].join(' ')}>
            <UserAvatar url={sender.avatarUrl} name={`${sender.name} ${sender.surname}`} />
            <div className="msgWrapper">
                <div className="msgBubble">
                    {data.extra && <AiNoteExtra messageId={data.id} extra={data.extra} />}
                    <p>{data.body}</p>
                </div>
                <div className="msgMeta">
                    <span className="userName">{sender.name} {sender.surname}</span>
                    <span className="msgTime">{time}</span>
                </div>
            </div>
        </div>
    );
};

export default ChatMessage;
